import { addMonths, format, isSameMonth, startOfMonth, subMonths } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Props {
  value: Date;
  onChange: (value: Date) => void;
  inverted?: boolean;
}

export function NotaPrimeMesControle({ value, onChange, inverted = false }: Props) {
  const atual = startOfMonth(new Date());
  const proximoBloqueado = isSameMonth(value, atual);
  const botao = cn(
    'grid h-7 w-7 place-items-center rounded-full border transition-colors disabled:cursor-default disabled:opacity-30',
    inverted
      ? 'border-white/20 bg-white/10 text-white hover:bg-white/20'
      : 'border-border bg-card text-muted-foreground hover:border-primary/40 hover:text-primary',
  );

  return (
    <div className="flex items-center gap-1.5">
      <button type="button" className={botao} onClick={() => onChange(startOfMonth(subMonths(value, 1)))} title="Mês anterior">
        <ChevronLeft className="h-3.5 w-3.5" />
      </button>
      <span className={cn(
        'min-w-[112px] text-center text-[11px] font-bold capitalize tabular-nums',
        inverted ? 'text-white' : 'text-foreground',
      )}>
        {format(value, 'MMMM yyyy', { locale: ptBR })}
      </span>
      <button
        type="button"
        className={botao}
        onClick={() => onChange(startOfMonth(addMonths(value, 1)))}
        disabled={proximoBloqueado}
        title="Próximo mês"
      >
        <ChevronRight className="h-3.5 w-3.5" />
      </button>
    </div>
  );
}
